import logoPse from '../../../assets/img/icons/logoPse.png'

const ListMethodPays = [
    {
        key: "1",
        rutaImagen: logoPse,
        nombrePago: 'Pago Seguro en Linea'
    }
]

export default ListMethodPays;